import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface DatabricksConfig {
  baseUrl: string;
  spaceId: string;
  clientId: string;
  clientSecret: string;
}

@Injectable({
  providedIn: 'root'
})
export class DatabricksGenieService {
  private http: HttpClient;

  constructor(private handler: HttpBackend) { 
    this.http = new HttpClient(this.handler);
  }

  // 1. Login
  login(config: DatabricksConfig): Observable<any> {
    const body = new HttpParams()
      .set('grant_type', 'client_credentials')
      .set('scope', 'all-apis')
      .set('client_id', config.clientId)
      .set('client_secret', config.clientSecret);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post(`${config.baseUrl}/oidc/v1/token`, body, { headers });
  }

  // 2. Start Chat
  startConversation(config: DatabricksConfig, token: string, content: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
    
    const body = { content };

    return this.http.post(`${config.baseUrl}/api/2.0/genie/spaces/${config.spaceId}/start-conversation`, body, { headers });
  }

  // 3. Get Chat Message
  getMessage(config: DatabricksConfig, token: string, chatId: string, messageId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.get(`${config.baseUrl}/api/2.0/genie/spaces/${config.spaceId}/conversations/${chatId}/messages/${messageId}`, { headers });
  }

  // 4. Next Question
  nextQuestion(config: DatabricksConfig, token: string, chatId: string, content: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const body = { content };

    return this.http.post(`${config.baseUrl}/api/2.0/genie/spaces/${config.spaceId}/conversations/${chatId}/messages`, body, { headers });
  }
  // 5. Get Attachment
  getAttachment(config: DatabricksConfig, token: string, chatId: string, messageId: string, attachmentId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.get(`${config.baseUrl}/api/2.0/genie/spaces/${config.spaceId}/conversations/${chatId}/messages/${messageId}/attachments/${attachmentId}/query-result`, { headers });
  }

  // 6. Get Statement Result
  getStatementResult(config: DatabricksConfig, token: string, statementId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.get(`${config.baseUrl}/api/2.0/sql/statements/${statementId}`, { headers });
  }
}
